// 调证文件上传页面翻译
export default {
  title: "调证文件",
  buttons: {
    upload: "上传调证",
    reset: "重置",
    query: "查询",
  },
  placeholders: {
    fileName: "请输入调证文件名称",
    caseName: "请输入案件名称",
    platform: "请选择调证平台",
    parseResult: "请选择解析结果",
    uploader: "请输入上传人",
    startDate: "开始日期",
    endDate: "结束日期",
  },
  total: {
    prefix: "共计",
    suffix: "条数据",
  },
  guide: {
    uploadTip: "点击可上传解析您的调证文件",
  },
  messages: {
    uploadSuccess: "上传调证成功",
  },
  table: {
    loading: "拼命加载中",
    columns: {
      evidenceFile: "调证文件",
      case: "案件",
      platform: "平台",
      parseResult: "解析结果",
      uploader: "上传人",
      uploadTime: "上传时间",
      operation: "操作",
    },
    actions: {
      download: "下载",
      downloading: "下载中...",
    },
    noData: "--",
  },
};
